import { Configuration } from '@willow/graphql-iso/src/app';

/**
 * @deprecated
 * Use shared-iso getPaymentDueDay
 */
export const isPaymentDateSettingFor25th = (configuration: Configuration): boolean => {
  const { productType, constructionLoanType, firstDueDate } = configuration;

  return Boolean((productType === 'heloc' || constructionLoanType) && new Date(firstDueDate).getDate() === 25);
};
